var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowForward = function SvgArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 43 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m21.59 28 7-7-7-7m7 7h-14"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.143,
    height: 40.143,
    x: 41.662,
    y: 41.071,
    stroke: "#000",
    rx: 20.071,
    transform: "rotate(-180 41.662 41.071)"
  })));
};
export default SvgArrowForward;